export const PAYMENT_STATUS = {
    COMPLETED: 'Completed',
    IN_PROGRESS: 'InProgress',
    PENDING: 'Pending',
    PAYMENT_NOT_MET: 'PaymentRequirementNotMet'
};

export const TAX_PROFILE_STATUS = {
    NULL: 'NULL',
    NAME_MISS_MATCH: 'NameMismatch',
    INVALID_TAX_INFO: 'InvalidTaxInfo',
    MISSING_TAX_INFO: 'MissingTaxInfo',
    DEACTIVATED: 'Deactivated',
    TAX_INFO_REQUIRES_UPDATE: 'TaxInfoRequiresUpdate',
    VALIDATED_TAX_INFO: 'ValidatedTaxInfo',
    TAX_INFO_ON_FILE: 'TaxInfoOnFile',
    VALIDATION_DEFERRED: 'ValidationDeferred',
    TAX_INFO_NOT_REQUIRED: 'TaxInfoNotRequired'
};
